var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profitloss && _vm.balance)?_c('div',{staticClass:"ratio-item"},[_c('div',{staticClass:"items-title"},[_vm._v(" "+_vm._s(_vm.title))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }